import { VERSION } from '../constants';

export const loadAPIVersion = () => ({
  type: VERSION,
});
